import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/general/pwa.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/menu/menuBottom.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/core/menu/menuTabContainer.component.tsx");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/node_modules/@excalidraw/excalidraw/dist/prod/index.css");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/core/style/tailwind.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/share/nginx/html/pwatools/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/usr/share/nginx/html/pwatools/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Vazirmatn\",\"arguments\":[{\"subsets\":[\"arabic\"],\"variable\":\"--vazirmatn\"}],\"variableName\":\"vazirmatn\"}");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/node_modules/swiper/swiper.scss");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/node_modules/swiper/modules/navigation.scss");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/node_modules/swiper/modules/pagination.scss");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/node_modules/swiper/modules/scrollbar.scss");
;
import(/* webpackMode: "eager" */ "/usr/share/nginx/html/pwatools/node_modules/swiper/modules/mousewheel.scss");
